import gql from "graphql-tag";

const POSTS_QUERY = gql`  
  query Posts {
    posts {
        id
        slug
        title
        content
        categories { 
            id
            name
        }
        authors {
          id
          firstName
          lastName
        }
        createdAt
        updatedAt
        published
    }
  }
`;

export default POSTS_QUERY;